export default {
  state: {
    accountBalance: null,
    connectedBankBalance: null,
    pgStatus: null
  },
  mutations: {
    SET_ACCOUNT_BALANCE: (state, payload) => {
      state.accountBalance = payload
    },
    SET_CONNECTED_BANK_BALANCE: (state, payload) => {
      state.connectedBankBalance = payload
    },
    SET_PG_STATUS: (state, payload) => {
      state.pgStatus = payload
    }
  },
  getters: {
    getterAccountBalance: state => state.accountBalance,
    getterConnectedBankBalance: state => state.connectedBankBalance,
    getterPgStatus: state => state.pgStatus
  }
}
